import React from 'react'
import { createRoot } from 'react-dom/client'
import ForTeachersPage from 'components/ForTeachersPage'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('for-teachers-page')
  if (container) {
    const translations = JSON.parse(container.dataset.translations || '{}')
    const root = createRoot(container)
    root.render(<ForTeachersPage translations={translations} />)
  }
})
